import throttle from 'lodash/throttle';

const sticky = ({
  container = document.documentElement,
  elementSelector,
  offsetTop = 0,
  offsetBottom = 0,
}) => {
  const element = document.querySelector(elementSelector);

  if (!element) {
    return;
  }

  element.classList.add('sticky');

  const recalc = () => {
    const el = document.querySelector(elementSelector);
    const scrollTop = window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const scrollBottom = scrollTop + window.innerHeight;
    const containerBottom = container.offsetHeight + container.offsetTop;
    const limit = containerBottom + (window.innerHeight - el.offsetHeight) - offsetTop - offsetBottom;

    if (scrollTop < container.offsetTop - offsetTop) {
      el.classList.remove('sticky--stuck');
      el.classList.add('sticky--top');
    }
    else if (scrollBottom > limit) {
      el.classList.remove('sticky--stuck');
      el.classList.add('sticky--bottom');
    }
    else {
      el.classList.add('sticky--stuck');
      el.classList.remove('sticky--bottom');
      el.classList.remove('sticky--top');
    }
  };

  window.addEventListener('scroll',
    throttle(recalc,
      25),
    false);
  if (!document.querySelector(elementSelector)) {
    setTimeout(recalc,
      500);
  }
  else {
    recalc();
  }
};

export default sticky;
